// extracted by mini-css-extract-plugin
module.exports = {"root":"AudioPlayer_root__Q7Nlb","caption":"AudioPlayer_caption__qzFuC","player":"AudioPlayer_player__rD9lQ","withImage":"AudioPlayer_withImage__pVL4C"};